import React from "react";
import { NumberTicker } from "../NumberTicker";

const TransformingTourism: React.FC = () => {
  return (
    <div className="grid gap-10 md:grid-cols-2">
      <div className="flex justify-center items-center">
        <div className="relative">
          <img
            src="/tourism/tourism-boy.png"
            alt=""
            className="w-72 lg:w-[27rem]"
          />
          <div className="absolute bottom-0 shadow-lg p-5 -left-10 lg:-left-16 bg-white rounded-lg">
            <div className="flex justify-center items-center">
              <img
                src="/tourism/tourism-location.svg"
                className="w-12 h-12"
                alt=""
              />
            </div>
            <div className="pt-3 flex flex-col items-center">
              <h3 className="text-center text-[#FF7E00] lg:text-3xl font-bold">
                <NumberTicker
                  value={25}
                  className="text-[#FF7E00]  font-bold"
                />
                +
              </h3>
              <p className="text-[#939597] max-w-20 lg:max-w-32 text-xs text-center lg:text-xl ">
                Cities Across India and Abroad Already Partnered
              </p>
            </div>
          </div>
          <div className="absolute -bottom-12 shadow px-5 py-3 -right-2 bg-white rounded-lg">
            <div className="pt-3 flex flex-col items-center">
              <div className="flex items-center gap-3 lg:gap-6">
                <div className="flex justify-center items-center">
                  <img
                    src="/tourism/tourism-signal.svg"
                    className="w-6 h-6"
                    alt=""
                  />
                </div>
                <h3 className="text-center lg:text-2xl">
                  <NumberTicker value={5000} />+
                </h3>
              </div>
              <p className="text-[#5B5F62] max-w-20 lg:max-w-32 text-xs  lg:text-xl ">
                Users
              </p>
              <p className="text-[#5B5F62] max-w-20 lg:max-w-32 text-xs  lg:text-xl ">
                Worldwide
              </p>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div className="text-[#182152] pt-10 lg:pt-0 text-3xl sm:text-4xl lg:text-5xl xl:text-6xl">
          <h3>Transforming</h3>
          <h3>Tourism with</h3>
          <h3>Technology</h3>
        </div>
        <p className="text-[#5B5F62] pt-5 lg:text-xl xl:text-2xl max-w-[27rem] xl:max-w-[28rem]">
          Empowering landmarks and destinations with cutting-edge technology to
          create unforgettable, immersive tourist experiences
        </p>
        <div className="pt-10 grid grid-cols-3 gap-5">
          <div className="flex flex-col items-center">
            <div className="flex justify-center items-center font-bold text-2xl lg:text-3xl xl:text-5xl">
              <NumberTicker
                value={10}
                className="text-[#182152] font-bold text-2xl lg:text-3xl xl:text-5xl"
              />
              +
            </div>
            <p className="text-center max-w-44 text-[#939597] lg:pt-2 lg:leading-loose pt-3">
              <span className="font-bold">Million</span> Audio Guides Played
              Worldwide
            </p>
          </div>
          <div className="flex flex-col items-center">
            <div className="flex justify-center items-center font-bold text-2xl lg:text-3xl xl:text-5xl">
              <NumberTicker
                value={95}
                className="text-[#182152] font-bold text-2xl lg:text-3xl xl:text-5xl"
              />
              +
            </div>
            <p className="text-center max-w-44 text-[#939597] lg:pt-2 lg:leading-loose pt-3">
              Positive Feedback from Tourists Using Our App
            </p>
          </div>
          <div className="flex flex-col items-center">
            <div className="flex justify-center items-center font-bold text-2xl lg:text-3xl xl:text-5xl">
              <NumberTicker
                value={40}
                className="text-[#182152] font-bold text-2xl lg:text-3xl xl:text-5xl"
              />
              +
            </div>
            <p className="text-center max-w-44 text-[#939597] lg:pt-2 lg:leading-loose pt-3">
              Languages Supported for Global Accessibility
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TransformingTourism;
